import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_process_tracking_einvoice_hdr_RowClass } from '../../../dbschema/index';

export class ProcessTrackingEinvoiceContainer extends BaseContainerModel {
  bl_b2b_process_tracking_einvoice_hdr: bl_b2b_process_tracking_einvoice_hdr_RowClass = new bl_b2b_process_tracking_einvoice_hdr_RowClass();
}
